module.exports = __webpack_public_path__ + "img/monitorBanner.46caeabe.png";